import React from 'react';
import TaskManager from './components/TaskManager';
import SetupScreen from './components/SetupScreen';
import { hasConfig } from './components/appConfig';
import './App.css';

function App() {
  const ready = hasConfig();

  return (
    <div className="app">
      <header className="app-header">
        <h1>MyTaskLog</h1>
      </header>
      {ready ? <TaskManager /> : <SetupScreen />}
    </div>
  );
}

export default App;
